/** 访问过载：Nginx 503 / API 429·503 / 手动开关 统一处理 */

export const OVERLOAD_PATH = '/overload.html'

export function isOverloadModeEnabled(): boolean {
  return import.meta.env.VITE_OVERLOAD_MODE === 'true'
}

export function isOverloadStatus(status: number): boolean {
  return status === 429 || status === 503
}

/** 跳转到静态过载页（避免在 SPA 内重复跳转） */
export function redirectToOverload(): void {
  if (typeof window === 'undefined') return
  if (window.location.pathname === OVERLOAD_PATH) return
  window.location.replace(OVERLOAD_PATH)
}
